import React, { useEffect } from 'react'
import { Button, Checkbox, Fade, FormControl, FormControlLabel, Menu, MenuItem, Radio, RadioGroup, Stack, Typography, useTheme, } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SortIcon from '@mui/icons-material/Sort';
import FilterButtons from './FilterButtons';
import { useTranslation } from 'react-i18next';

export default function FilterWithSorting({ headData, onChange, sortChange }) {
  const theme = useTheme();
  const { t } = useTranslation();

  const [checkboxLists, setCheckboxLists] = React.useState(headData?.filter?.filterList);
  const [checkList, setCheckList] = React.useState(headData?.filter?.filterType === 'checkbox' ? [] : null);

  const [sortOrder, setSortOrder] = React.useState(headData?.sortOrder || null);

  useEffect(() => {
    setSortOrder(headData?.sortOrder)
  }, [headData?.sortOrder])

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setSortOrder(headData?.sortOrder || null)
    setAnchorEl(null);
  };

  const handleChange = (event) => {
    if (event.target.checked === true) {
      setCheckList([...checkList, event.target.value]);
    } else {
      const selectedAcc = checkList.filter(a => {
        if (a === event.target.value) return false;
        return true;
      });

      setCheckList([...selectedAcc]);
    }
  };

  const handleRadioChange = (event) => {
    setCheckList(event.target.value);
  };

  const handleSubmit = (btntype) => {
    const updateObj = {...headData};
    updateObj.filter.selectValue = btntype === 'Reset' || (!Boolean(checkList) || checkList?.length === 0) ? null : checkList || [];
    onChange({
      ...updateObj, sort: sortOrder ? {
        field: btntype === 'Reset'? '_id': headData?.accessor,
        order: btntype === 'Reset'? 'desc' :sortOrder,
        id: headData?.id
      } : null
    });
    if (btntype === 'Reset') {
      setSortOrder(null);
      setCheckList(headData?.filter?.filterType === 'checkbox' ? [] : null)
    }
    setCheckboxLists(headData?.filter?.filterList);
    setAnchorEl(null);
  };

  const changeSorting = () => {
    if (sortOrder) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
      // sortChange({
      //   field: headData?.accessor,
      //   order: order,
      //   id: headData?.id
      // })
    } else {
      setSortOrder('asc');
      // sortChange({
      //   field: headData?.accessor,
      //   order: 'asc',
      //   id: headData?.id
      // })
    }
  }

  return (
    <React.Fragment>
      <Stack
        id="fade-button"
        variant="text"
        disableRipple={true}
        disableElevation={true}
        disableFocusRipple={true}
        disableTouchRipple={true}
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className="!text-[12px] !capitalize cursor-pointer h-[48px] filterMenu"
        flexDirection={'row'}
        alignItems={'center'}
        sx={{ pl: 0 }}
      >
        {t(headData?.header)}
        <Stack alignItems={'center'} justifyContent={'center'} className={`h-[20px] w-[20px] rounded-[4px] ml-[20px]  ${Boolean(headData?.sortOrder) || Boolean(headData?.filter?.selectValue && headData?.filter?.selectValue?.length > 0) ? 'arrowIcon-active' : ''}`}>
          <ArrowDropDownIcon className='arrowIcon' />
        </Stack>
      </Stack>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      > 
        <MenuItem onClick={changeSorting} sx={{color: sortOrder ? theme.palette.primary.light :theme.palette.primary.text}}>
          <SortIcon sx={{ transform: sortOrder === 'asc' ? 'rotate(180deg)' : 'rotate(0deg)' }} color={'red'} />
          <Typography className="!text-[14px] !ml-[16px]" color={sortOrder ? theme.palette.primary.light :theme.palette.primary.text}>{t('Sort')}</Typography>
        </MenuItem>
        {checkboxLists.length > 0 && <Stack>
          <Typography color={'#64717C'} className="!text-[12px] !ml-[16px]">Filters</Typography>
        </Stack>}
        {headData?.filter?.filterType === 'checkbox' && checkboxLists?.map((checkbox, index) => (
          <MenuItem
            key={index + checkbox.label}>
            <FormControlLabel
              labelPlacement="end"
              control={
                <Checkbox
                  sx={{ p: 0, pr: '16px', pl: '11px', "& .MuiSvgIcon-root": {
                    height: 18,
                    width: 18,
                  } }}
                  onChange={handleChange}
                  value={checkbox?.value}
                  checked={
                    checkList.lastIndexOf(checkbox?.value) >= 0 ? true : false
                  }
                  name={checkbox.label}
                  id={checkbox.value}
                  color={"primary"}
                />
              }
              label={<Typography color={theme.palette.primary.text} className='!text-[14px]'>{checkbox?.label || '-'}</Typography>}
            />
          </MenuItem>
        ))}
        {headData?.filter?.filterType === 'radio' && checkboxLists.length > 0 && <FormControl className='!px-[16px]'>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            value={checkList}
            onChange={handleRadioChange}
          >
            {checkboxLists?.map((radio, index) => <FormControlLabel key={index} value={radio.value} control={<Radio sx={{
              "& .MuiSvgIcon-root": {
                height: 18,
                width: 18,
              }
            }} />} label={<Typography color={theme.palette.primary.text} className='!text-[14px]'>{radio.label}</Typography>} />)}

          </RadioGroup>
        </FormControl>}
        {<Stack style={{ borderTop: 'solid 0.01px #cecccc', background: theme.palette.background.main }}
          direction="row" spacing={1} className='!px-[6px] !pt-[8px] !justify-around !sticky !bottom-[0]'>
          <FilterButtons name={`Reset`} onClick={(btnType) => { handleSubmit(btnType) }} />
          <FilterButtons disabled={!((checkList && checkList.length > 0) || headData?.filter?.selectValue || Boolean(sortOrder))} name={`Apply`} onClick={(btnType) => { handleSubmit(btnType) }} />
        </Stack>}
      </Menu>
    </React.Fragment>
  )
}
